<template>
    <div class="col-sm-3">
        <div class="left-sidebar">
            <h2>Categorias</h2>
            <div class="panel-group category-products" id="accordian"><!--category-productsr-->
                <div class="panel panel-default" v-for="cat in categorias">
                    <div class="panel-heading">
                        <h4 class="panel-title" style="text-align: left;">
                            <a data-toggle="collapse" data-parent="#accordian" @click="$emit('filterCategoria', cat.id)">
                                <!-- <span class="badge pull-right"><i class="fa fa-plus"></i></span> -->
                                {{cat.nome}}
                            </a>
                        </h4>
                    </div>
                    <!-- <div id="sportswear" class="panel-collapse collapse">
                        <div class="panel-body">
                            <ul>
                                <li><a href="">Subcategoria 1 </a></li>
                                <li><a href="">Subcategoria 2 </a></li>
                            </ul>
                        </div>
                    </div> -->
                </div>
                <!-- <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordian" href="#mens">
                                <span class="badge pull-right"><i class="fa fa-plus"></i></span>
                                Categoria 2
                            </a>
                        </h4>
                    </div>
                    <div id="mens" class="panel-collapse collapse">
                        <div class="panel-body">
                            <ul>
                                <li><a href="">Subcategoria 1</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title"><a href="#">Categoria 3</a></h4>
                    </div>
                </div> -->
                
            </div><!--/category-productsr-->
        
        </div>
    </div>
</template>
<script>
import firebase from 'firebase';

export default {
    name: 'Group Categoria',
    data() {
		return {
			categorias: []
		}
	},
	created() {
		this.getCategoria();
    },
    methods: {
		getCategoria() {
			var cat = firebase.database().ref('categorias/')
			cat.on('child_added', (data) => {
				this.categorias.push({ nome: data.val().nome, id: data.key})
			});
        }
    }
}
</script>
